import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { LinearProgress, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import styles from './ChecklistCard.module.css';
import CheckpointCard from '../checkpointCard/CheckpointCard';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ChecklistIcon from '@mui/icons-material/Checklist';
interface ChecklistCardProps {
	checklist: PatrolChecklist | undefined;
}
const ChecklistCard = (props: ChecklistCardProps) => {
	const [showCheckpoints, setShowCheckpoints] = useState<boolean>(false);
	const counts = {
		total: 0,
		completed: 0,
		incomplete: 0,
		info: 0,
		clear: 0,
		warning: 0,
		emergency: 0,
	};

	props.checklist?.Checkpoints.forEach((checkpoint) => {
		counts.total += 1;
		switch (checkpoint.CompletionStatus) {
			case 'Incomplete':
				counts.incomplete += 1;
				break;
			case 'Info':
				counts.info += 1;
				counts.completed += 1;
				break;
			case 'Clear':
				counts.clear += 1;
				counts.completed += 1;
				break;
			case 'Warning':
				counts.warning += 1;
				counts.completed += 1;
				break;
			case 'Emergency':
				counts.emergency += 1;
				counts.completed += 1;
				break;
			default:
				counts.incomplete += 1;
				break;
		}
	});
	return (
		<>
			<Card variant="elevation">
				<CardContent>
					<Box className={styles.checklistTypeWrapper}>
						{props.checklist?.Type === 'Incident' ? (
							<WarningAmberIcon color="warning" />
						) : (
							<ChecklistIcon color="primary" />
						)}

						<Typography
							sx={{ fontSize: 14 }}
							color="text.secondary"
							gutterBottom
						>
							{props.checklist?.Type} Checklist
						</Typography>
					</Box>

					<Typography variant="h6" component="div">
						{props.checklist?.Name}
					</Typography>
					<Typography sx={{ mb: 1.5 }} color="text.secondary">
						{counts.total} checkpoints
					</Typography>
					<Typography
						sx={{ fontSize: 14 }}
						color="text.secondary"
						gutterBottom
					>
						{counts.completed}/{counts.total} checkpoints completed{' '}
						<br />
						{[
							{
								count: counts.info,
								label: 'Info',
								color: 'primary',
							},
							{
								count: counts.clear,
								label: 'Clear',
								color: 'success.light',
							},
							{
								count: counts.warning,
								label: 'Warning',
								color: 'warning.light',
							},
							{
								count: counts.emergency,
								label: 'Emergency',
								color: 'error',
							},
							{
								count: counts.incomplete,
								label: 'Incomplete',
								color: 'text.disabled',
							},
						].map(({ count, label, color }, index) => (
							<React.Fragment key={label}>
								{index > 0 && ' | '}
								<Typography
									sx={{ fontSize: 14 }}
									component="span"
									color={color}
								>
									{count} {label}
								</Typography>
							</React.Fragment>
						))}
					</Typography>
					<LinearProgress
						variant="determinate"
						value={(counts.completed / counts.total) * 100}
						color="success"
					/>
				</CardContent>
				<CardActions>
					<Box flexGrow={1} />
					<Button
						size="small"
						onClick={() => setShowCheckpoints((prev) => !prev)}
					>
						{showCheckpoints ? 'hide' : 'View'} Checkpoints
					</Button>
				</CardActions>
				{showCheckpoints && (
					<CardContent
						sx={{
							gap: '0.5rem',
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						{props.checklist?.Checkpoints.map(
							(checkpoint, index) => (
								<div key={index}>
									<CheckpointCard
										checkpoint={checkpoint}
										index={index}
									/>
								</div>
							),
						)}
					</CardContent>
				)}
			</Card>
		</>
	);
};
export default ChecklistCard;
